import React, { useEffect, useState } from "react";
import Spinner from "../../../components/_common/Spinner";
import OneBarChart from  '../../../components/_common/BarChart/OneBarChart'
import { errorNotify } from "../../../services/toast.notification";
import { getMiscellaneousFunctions,getRemoteAccessList} from '../../../api/api';
import { useAppDispatch, useAppSelector } from '../../../redux/store/storehooks';
import { UpdateMiscellaneousFunctions } from "../../../redux/reducers/MiscellaneousFunctionsSlice";
import '../style.css';
import { DatePicker as DatePickerJalali, JalaliLocaleListener, useJalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import 'dayjs/locale/fa';
import { ConfigProvider } from "antd";

export interface InputProps {
  url: any
}

const RemoteAccess = ({url}:InputProps) => {
  var moment = require('jalali-moment');  

  let chartData:any[]=[];
  let flag = false;

  const [isLoading,setIsLoading] = useState(false);
  const [firstDate,setFirstDate] = useState<any>(undefined);
  const [lastDate,setLastDate] = useState<any>(undefined);
  const [data,setData] = useState<any>([]);

  function onChangeDatePicker(dates: any, dateStrings: any, info: any) {
   
    setIsLoading(true);

    if (!dateStrings) return;
    if (dateStrings.length < 2) return;
    if (dateStrings[0] === "") return;
    if (dateStrings[1] === "") return;
   
    setFirstDate(dates[0]);
    setLastDate(dates[1]);
   
    let _fromDate = moment.from(dateStrings[0], 'fa', 'YYYY-M-D')
    .format('YYYY-M-D');
    let _toDate = moment.from(dateStrings[1], 'fa', 'YYYY-M-D')
    .format('YYYY-M-D');

    _getRemoteAccess(url,2,_fromDate,_toDate);
  }

  const _getRemoteAccess = (url:string,func:number,fromdate:string,todate:string) => {
    getMiscellaneousFunctions(url,func,fromdate,todate)
    .then((result:any) => {
      let jsonResult = JSON.parse(result.data.json);
      let new_result = getRemoteAccessList(jsonResult.RemoteAccessResult);
      setData(new_result);
      setIsLoading(false);
    })
    .catch((error:any) => {
      console.log(error);
      errorNotify(error.response.data.errorMessage,undefined,5000)
    })    
}

  useEffect(() => {
    //_getRemoteAccess(url,2,'2021-01-01','2023-08-05');
  }, [])
 
  const getChartData =()=>{
    data.map((item:any)=>{
      chartData.push({name:item.sub_source, count:item.count,color:'rgb(241, 145, 50)'});
    })

    chartData.map((item:any)=>{
      if(item.count !==0 ) {
        flag = true;
        return;
      }
    })
  }
 
  return (
    <> 
    <div className="calender">
      <ConfigProvider locale={fa_IR} direction="rtl">
          <JalaliLocaleListener />
          <DatePickerJalali.RangePicker value={[firstDate,lastDate]}  onCalendarChange={(dates:any,dateStrings:any,info:any)=>onChangeDatePicker(dates,dateStrings,info)} />
          </ConfigProvider>
    </div>
    {isLoading === false && (
        getChartData(),
        <>
            { 
              flag &&(
                  <OneBarChart data={chartData} label="" dataKey="count"/>
        )
      } 
      {
       flag === false &&
       (<p className="empty-data">داده ای برای نمایش موجود نیست.</p>)
      }
      </>
     )
     
 }

    {isLoading === true && (
        <Spinner />
    )}

    </>
  )
}
export default RemoteAccess;